'use strict';
const compactedGroupWidth = require('./compacted-group-width'),
	sortNodesByLeftPosition = require('./sort-nodes-by-left-position');
module.exports = function alignGroup(result, rootIdea, margin) {
	if (!margin) {
		throw 'invalid-args';
	}
	const nodes = result.nodes,
		rootNode = nodes[rootIdea.id],
		childIds = Object.values(rootIdea.ideas || {}).map(idea => idea.id),
		childNodes = childIds.map((id) => {
			return nodes[id];
		}).filter((node) => {
			return node;
		}),
		sortedChildNodes = sortNodesByLeftPosition(childNodes),
		getChildNodeBoundaries = function () {
			const rightMost = sortedChildNodes[sortedChildNodes.length - 1];
			return {
				left: sortedChildNodes[0].x,
				right: rightMost.x + rightMost.width
			};
		},
		setGroupWidth = function () {
			if (!childNodes.length) {
				return;
			}
			const levelBoundaries = getChildNodeBoundaries();
			rootNode.x = levelBoundaries.left;
			rootNode.width = levelBoundaries.right - levelBoundaries.left;
		},
		compactChildNodes = function () {
			if (!childNodes.length) {
				return;
			}
			const levelBoundaries = getChildNodeBoundaries(),
				levelCenter = levelBoundaries.left + (levelBoundaries.right - levelBoundaries.left) / 2,
				requiredWidth = compactedGroupWidth(childNodes, margin);
			let position = levelCenter - requiredWidth / 2;
			sortedChildNodes.forEach(node => {
				node.x = position;
				position = position + node.width + margin;
			});
		},
		sameLevelNodes = Object.values(nodes || {}).filter((node) => {
			return node.level === rootNode.level && node.id !== rootNode.id;
		});

	compactChildNodes();
	setGroupWidth();

	sameLevelNodes.forEach((node) => {
		node.verticalOffset = (node.verticalOffset || 0) + rootNode.height;
	});
};
